interface ToggleProps {
  value: boolean;
  onChange: (v: boolean) => void;
  ariaLabel?: string;
}

export function Toggle({ value, onChange, ariaLabel }: ToggleProps) {
  return (
    <button
      role="switch"
      aria-checked={value}
      aria-label={ariaLabel}
      onClick={() => onChange(!value)}
      type="button"
      style={{
        width: 44,
        height: 24,
        border: "var(--border-thin)",
        background: value ? "var(--ink-0)" : "var(--surface)",
        borderRadius: 999,
        position: "relative",
        cursor: "pointer",
        padding: 0,
        transition: "all var(--dur-fast)",
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 2,
          left: value ? 22 : 2,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: value ? "var(--bg)" : "var(--ink-0)",
          transition: "all var(--dur-fast)",
        }}
      />
    </button>
  );
}
